import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Stack from "@mui/material/Stack";

import TagsEditor from "./TagsEditor";
import ProjectDefinition from "./ProjectDefinition";
import ProjectMediaDefs from "./ProjectMediaDefs";
import ProjectContentSexual from "./ProjectContentForm/ProjectContentSexual";
import ProjectContentViolence from "./ProjectContentForm/ProjectContentViolence";
import { useCreateProjectMutation } from "services/project/projectApi";
import { v4 as uuidv4 } from "uuid";
import ImagesEditor from "./ImagesEditor";

import CloudUpload from "@mui/icons-material/CloudUpload";
import { useParams } from "react-router-dom";

const ProjectEditor = () => {
  const methods = useForm();

  const [createProject, { data, isLoading }] = useCreateProjectMutation();
  const { passkey } = useParams();
  
  // const { data: project, error, projectIsLoading} =

  const onSubmit = (data: any) => {
    const project = {
      ...data,
      uid: uuidv4(),
      name: data.title.replaceAll(/\s+/gi, "_"),
    };

    createProject({ project, passkey});
  };

  React.useEffect(() => console.log(methods.getValues()));

  return (
    <Stack
      direction="row"
      sx={{ alignItems: "center", justifyContent: "center" }}
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid container spacing={2} columnGap={2} rowGap={2} margin={5}>
            <ProjectDefinition />
            <ProjectMediaDefs />

            <Grid container xs={12} spacing={2} rowGap={2} columnGap={2}>
              <ProjectContentSexual />
              <ProjectContentViolence />
            </Grid>

            <Grid xs={12}>
              <ImagesEditor
                name="images" 
                defaultImageType="project" />
            </Grid>

            <Grid xs={12}>
              <TagsEditor name="tags" />
            </Grid>

            <Button
              variant="contained"
              startIcon={<CloudUpload />}
              type="submit"
            >
              Submit
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </Stack>
  );
};

export default ProjectEditor;
